import TwilioInitMenu from "./TwilioInitMenu.component.jsx";

export default TwilioInitMenu;